import apiClient from "./axios";

export const getChassisCodes = async (params = {}) => {
  const { data } = await apiClient.get("/chassis-codes", { params });
  return data;
};

export const getChassisCode = async (id) => {
  const { data } = await apiClient.get(`/chassis-codes/${id}`);
  return data;
};

export const createChassisCode = async (payload) => {
  const { data } = await apiClient.post("/chassis-codes", payload);
  return data;
};

export const editChassisCode = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/chassis-codes/${id}`, payload);
  return data;
};

export const deleteChassisCode = async (id) => {
  const { data } = await apiClient.delete(`/chassis-codes/${id}`);
  return data;
};
